module.exports = "/_next/static/images/stack-896e5ac1a02869e654d52654e3e4f41e.svg";